import logo from '../image/vodin_logo.svg';

export function LogoView(){
    return (
        <div 
            style={{display:"flex", flexDirection: "column",  padding: "1px"}}
        >
       <img
       alt="Vodin Logo"
      width={50}
      src={logo}
    />
        </div>
    )
}